// extracted by mini-css-extract-plugin
export var messageSideLeft = "_j3-1";
export var messageSideRight = "_j3-2";
export var orderLookupBubbleContainer = "_j3-0";
export var submitButton = "_j3-3";